import {
  fetchCompaniesRequest,
  fetchCertainCompanyRequest,
  createCompanyRequest,
  editCompanyRequest,
  addUserToCompanyRequest,
  removeUserFromCompanyRequest,
} from 'api';
import { PaginationType } from 'common';
import { Pagination, Roles } from 'enums';
import {
  setCompaniesPagination,
  setAuthLoading,
  setCertainCompany,
  setCompanies,
  setCompaniesAfterScroll,
  setNotification,
  setCompaniesLoadingStatus,
} from 'state/actions';
import { AppRootStateType } from 'state/reducers';
import { TypedDispatch } from 'state/types';

export const fetchCompanies =
  (isScroll: boolean) =>
  async (dispatch: TypedDispatch, getState: () => AppRootStateType) => {
    const page = isScroll ? getState().companies.page : Pagination.START_PAGE;
    const search = getState().companies.search.trim();
    const id =
      getState().auth.user.role === Roles.SUPER_ADMIN
        ? ''
        : getState().auth.user.company?.id ?? '';

    try {
      dispatch(setCompaniesLoadingStatus(true));
      const response = await fetchCompaniesRequest({
        page,
        q: search || undefined,
        take: Pagination.TAKE,
        id,
      });
      const pagination: PaginationType = {
        page: response?.data.page,
        count: response?.data.count,
      };

      dispatch(setCompaniesPagination(pagination));
      dispatch(
        isScroll
          ? setCompaniesAfterScroll(response?.data.rows)
          : setCompanies(response?.data.rows),
      );
    } finally {
      dispatch(setCompaniesLoadingStatus(false));
    }
  };

export const fetchCertainCompany = (id: string) => async (dispatch: TypedDispatch) => {
  try {
    dispatch(setCompaniesLoadingStatus(true));
    const response = await fetchCertainCompanyRequest(id);

    dispatch(setCertainCompany(response?.data));
  } finally {
    dispatch(setCompaniesLoadingStatus(false));
  }
};

export const createCompany = (name: string) => async (dispatch: TypedDispatch) => {
  try {
    dispatch(setAuthLoading(true));
    const response = await createCompanyRequest(name);

    return response;
  } finally {
    dispatch(setAuthLoading(false));
  }
};

export const editCompany =
  (name: string, id: string) => async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const response = await editCompanyRequest(name, id);

      dispatch(setNotification(response?.data?.message));

      return response?.status;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };

export const addUserToCompany =
  (companyId: string, userId: string) => async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const res: any = await addUserToCompanyRequest(companyId, userId);

      dispatch(setNotification(res?.data?.message));

      return res?.status;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };

export const removeUserFromCompany =
  (companyId: string, userId: string) => async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const res: any = await removeUserFromCompanyRequest(companyId, userId);

      dispatch(setNotification(res?.data?.message));

      return res?.status;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };
